import { Fragment } from 'react';

import { Table, VerticalSpacer } from '~/components/Elements';

import {
  Disclaimer,
  Headline,
  HeadlineSub,
  Intro,
  TableSideValue,
} from '../styles';

const Tracks = props => {
  const {
    type,
    data: { [type]: data },
  } = props;

  const start_methods = {
    A: 'Autostart',
    V: 'Voltstart',
  };

  const lists = {
    best: 'Högst segerprocent',
    worst: 'Lägst segerprocent',
  };

  return (
    <Fragment>
      {data.map((track, index) => (
        <Fragment key={track.track_id}>
          {index === 0 && (
            <Fragment>
              <Headline>{track['A'].headline}</Headline>
              <Intro>{track['A'].intro}</Intro>
            </Fragment>
          )}

          {data.length > 1 && <HeadlineSub>{track.track_name}</HeadlineSub>}

          {Object.keys(start_methods)
            .filter(m => track.hasOwnProperty(m))
            .map(start_method => (
              <Fragment key={start_method}>
                {Object.keys(lists)
                  .filter(k => track[start_method].hasOwnProperty(k))
                  .map(key => (
                    <Fragment key={key}>
                      <HeadlineSub>
                        {lists[key]} - {start_methods[start_method]}
                      </HeadlineSub>
                      <Table>
                        <thead>
                          <tr>
                            <th>Spår</th>
                            <th>Starter</th>
                            <th>Segrar</th>
                            <th>Segerprocent</th>
                            <th>ROI ATG</th>
                          </tr>
                        </thead>
                        <tbody>
                          {track[start_method][key].map(stat => (
                            <tr key={stat.track}>
                              <td>{stat.track}</td>
                              <td>{stat.count}</td>
                              <td>{stat.number_of_wins}</td>
                              <td>
                                {stat.win_percent}%
                                {stat.win_percent_total && (
                                  <TableSideValue>
                                    {stat.win_percent_total}%
                                  </TableSideValue>
                                )}
                              </td>
                              <td>
                                {stat.roi}%
                                {stat.roi_total && (
                                  <TableSideValue>
                                    {stat.roi_total}%
                                  </TableSideValue>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {data.length !== index + 1 && start_method === 'V' && (
                        <VerticalSpacer margin={15} />
                      )}
                    </Fragment>
                  ))}
              </Fragment>
            ))}
        </Fragment>
      ))}
      <Disclaimer>{data[0]['A'].disclaimer}</Disclaimer>
      <VerticalSpacer margin={30} />
    </Fragment>
  );
};

export default Tracks;
